"use client";

import { useEffect } from "react";
export default function ClientReviews() {
  useEffect(() => {
    const scriptSrc = "https://elfsightcdn.com/platform.js";
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <section id="clientreviews" className="bg-background py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="flex flex-col items-center justify-center mb-16 space-y-4 text-center">
          <h2 className="font-sans text-3xl md:text-4xl font-bold tracking-widest uppercase text-foreground">
            Client Reviews
          </h2>
          <p className="text-lg md:text-xl font-medium text-muted-foreground max-w-2xl">
            See what homeowners and buyers across South Florida are saying about Trusted Inspections.
          </p>
        </div>

        <div className="w-full max-w-5xl mx-auto bg-card border border-border rounded-2xl p-4 sm:p-8 shadow-sm">
          {}
          <div className="elfsight-app-78ec0d7a-eac8-4082-905c-8f83ada0ad84" data-elfsight-app-lazy></div>
        </div>
      </div>
    </section>;
}